import { HttpResponse } from '@angular/common/http';
import { DownloadedFile } from '@digilize/shared/definitions/src';
import { extractFilenameFromHeader } from '@digilize/shared/utils/helpers/src';

/** A blob response as a file: the body, and the name the backend put in `Content-Disposition`. */
export const toDownloadedFile = (response: HttpResponse<Blob>): DownloadedFile => ({
  blob: response.body as Blob,
  filename: extractFilenameFromHeader(response.headers.get('Content-Disposition')),
});
